import addReport from "./addReport";
import addReportExporting from "./addReportExporting";
import addReportFiltering from "./addReportFiltering";
import addReportGeospatialFilter from "./addReportGeospatialFilter";
import addReportPermissions from "./addReportPermissions";
import addReportSettings from "./addReportSettings";
import choseReportColumns from "./choseReportColumns";
import getReportColumns from "./getReportColumns";
import updateReport from "./updateReport";
import getReportGeospatialColumns from "./getReportGeospatialColumns";
import addBasicReport from "./addBasicReport";
import updateBasicReport from "./updateBasicReport";

const AddReportApis = {
  addReport,
  addReportPermissions,
  addReportSettings,
  updateReport,
  addReportExporting,
  getReportColumns,
  choseReportColumns,
  addReportGeospatialFilter,
  addReportFiltering,
  getReportGeospatialColumns,
  addBasicReport,
  updateBasicReport,
};

export default AddReportApis;
